import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import "swiper/css/pagination"
import "swiper/css/navigation"

import { Link } from "react-router-dom";
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import './Carousel.scss'
import { useEffect, useState } from 'react';

export default function Carousel({items, slidesToShow, isLogo, fullWidth}) {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  // Swiper necesita bastante más slides que slidesPerView para que el loop
  // infinito funcione sin warnings/glitches. Si no alcanzan, usamos rewind
  // (vuelve al principio al llegar al final) en vez de loop.
  const canLoop = items.length > slidesToShow * 2;

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    // Limpia el listener al desmontar el componente
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className={`carousel-container ${fullWidth ? 'full-width' : ''} ${isLogo ? 'low-heigth' : ''}`}>
      <Swiper
        spaceBetween= {1}
        slidesPerView={slidesToShow}
        loop={canLoop}
        rewind={!canLoop}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[Autoplay, Pagination, Navigation]}
        className={`${isLogo ? 'logo-type' : ''}`}
        >
          {items.map(n => (
          <SwiperSlide key={`carousel_${n.id}`} className={`${isLogo ? 'logo-type' : ''}`}>
            <Link to={`/${n.url}`}>
              { screenWidth > 520
                ?<img src={n.img} />
                : n.imgMobile && n.imgMobile != '' ? <img src={n.imgMobile} alt=""/> : <img src={n.img} />
              }
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}